import React, { useState } from 'react';
import BarRecherche from './BarRecherche';
import InfoEcole from './InfoEcole';
import ListeEcole from './ListeEcole';

const TrouveEcole = ({ setEcole_selection, code_dept, cheminpush, eni,info_ }) => {
  const [texte_recherche, setTexte_Recherche] = useState('');
  const [ecole_selectionne, setEcole_selectionne] = useState(null);

  // if (texte_recherche.length == 0) setEcole_selectionne(null);

  return (
    <div className='container justify-content-center mt-4'>
      <div className='row'>
        <div className='col-sm-12 col-md-8 col-lg-7'>
          <BarRecherche texte_recherche rechEcole={setTexte_Recherche} />
          {texte_recherche.length >= 1 && (
            <ListeEcole
              text_rech={texte_recherche}
              setEcole_selectionne={setEcole_selectionne}
              code_dept={code_dept}
              setTexte_Recherche
              eni={eni}
            />
          )}
        </div>
        {ecole_selectionne && texte_recherche && (
          <div className='col-sm-12 col-md-4 col-lg-5'>
            <InfoEcole
              ecole_selectionne={ecole_selectionne}
              setEcole_selection={setEcole_selection}
              setTexte_Recherche={setTexte_Recherche}
              // setEcole_selectionne={setEcole_selectionne}
              cheminpush={cheminpush}
              info_={info_}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TrouveEcole;
